import React from "react";
import "./Icon.css";
import { cssHost } from "./../../utils/config";

// Per-deploy asset path segment, injected ONLY by the new (Vite) build as
// "static/<version>" so public images resolve to the cache-busted, 1-year
// immutable /static tree. The legacy Parcel build does not set it, so it falls
// back to the unversioned path and its output is unchanged.
const assetVersion = process.env.CASA_ASSET_VERSION;

const Icon = ({ src, isWidgetIcon = true, className = "", ...props }) => {
  const iconSrc = process.env.NODE_ENV === 'development'
    ? `/${src}`
    : `${cssHost}/${assetVersion ? `${assetVersion}/` : ""}${src}`;

  return (
    <img
      src={iconSrc}
      {...props}
      className={`${className} ${isWidgetIcon && "widget-icon"}`}
    />
  );
};

export default Icon;
